import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import {
  addNewScholarshipApplication,
  fetchScholarshipApplicationList,
  updateScholarshipApplication,
} from "../../../app/redux/slices/scholarshipApplicationSlice";
import "../../../pages/styles.css";
import Swal from "sweetalert2";
import { useNavigate, useNavigation } from "react-router-dom";
import { fetchScholarshipApplicationByIdReq, uploadFormFilesReq,sendScholarshipEmailReq } from "../../../api/scholarshipapplication/scholarshipapplication"
import { publicAxios } from "../../../api/config";
import { ApiKey } from "../../../api/endpoint";
import { routePath as RP } from "../../../app/components/router/routepath";
// --- Regex validations ---
const nameRegex = /^[A-Za-z\s]{0,150}$/;
const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+\.(com|com\.au|edu)$/;
const phoneRegex = /^[0-9]{0,10}$/;
const courseRegex = /^[A-Za-z0-9(),|-\s-./]{0,150}$/;
const collegeRegex = /^[A-Za-z0-9(),-./\s]{0,250}$/;
const yearRegex = /^[0-9\-]{0,10}$/;
const gpaRegex = /^\d{0,2}(\.\d{1,2})?$/;
const scholarshipRegex = /^[A-Za-z0-9\s]{0,250}$/;
const text250Regex = /^[A-Za-z0-9\s.,'"%&(){}|//\-:;!?]{0,250}$/;
//const text250Regex = /^[A-\s\S]{0,250}$/;


/*const scholarshipOptions = [
  { id: 1, name: "National Merit Scholarship" },
  { id: 2, name: "Need-Based Education Grant" },
  { id: 3, name: "STEM Excellence Fellowship" },
  { id: 4, name: "Research Innovation Award" },
];*/



 const isValidEmail = (email) => {
    email = email.trim();

    // Basic regex: no spaces, contains @, proper chars
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!regex.test(email)) return false;

    const [local, domain] = email.split("@");
    if (!local || !domain) return false;

    // Local part rules
    if (local.startsWith(".") || local.endsWith(".")) return false;
    if (local.includes("..")) return false;

    // Domain rules
    if (domain.startsWith(".") || domain.endsWith(".")) return false;
    if (domain.includes("..")) return false;

    const domainParts = domain.split(".");
    if (domainParts.length < 2) return false;

    // Last two domain parts cannot be same (reject domain.com.com)
    const lastIndex = domainParts.length - 1;
    if (domainParts[lastIndex] === domainParts[lastIndex - 1]) return false;

    // Each domain part must contain only letters, numbers, hyphen (no special chars)
    for (let part of domainParts) {
      if (!/^[a-zA-Z0-9-]+$/.test(part)) return false;
      if (part.startsWith("-") || part.endsWith("-")) return false; // no hyphen at start/end
    }

    return true;
  };


const AddApplicationModal = ({ show, handleClose, application , mode }) => {
  const [scholarshipOptions, setScholarshipOptions] = useState([]);
  const [filteredScholarships, setFilteredScholarships] = useState([]);
  useEffect(() => {
    const fetchScholarships = async () => {
      try {
        const url = `${ApiKey.Scholarship}/status`;
        const params = { StatusType: "live" };
        const res = await publicAxios.get(url, { params });

        // ✅ Adjust mapping depending on API structure
        if (res.data && Array.isArray(res.data)) {
          const options = res.data.map((s) => ({
            id: s.id,
            name: s.name,
            scholarshipCode:s.scholarshipCode,
            type: s.scholarshipType,
          }));
          setScholarshipOptions(options);
        }
      } catch (error) {
        console.error("Error fetching scholarships:", error);
      }
    };

    fetchScholarships();
  }, []);
  // 🔍 Whenever category changes, filter scholarships

  const fileInputRef = useRef(null);
  const navigation = useNavigate();
  const dispatch = useDispatch();
  // Max allowed DOB = yesterday
const yesterday = new Date();
yesterday.setDate(yesterday.getDate() - 1);
const maxDOB = yesterday.toISOString().split("T")[0];
const isViewMode = mode === "view";
// Min allowed DOB = today - 79 years
const minDOB = new Date();
minDOB.setFullYear(minDOB.getFullYear() - 79);
const minAllowedDOB = minDOB.toISOString().split("T")[0];

  const today = new Date().toISOString().split("T")[0];
  //const minDOB = new Date(new Date().setFullYear(new Date().getFullYear() - 79))
   // .toISOString()
    //.split("T")[0];
  const initialFormData = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    dateOfBirth: "",
    gender: "",
    studyLevel: "",
    schoolName: "",
    courseOrMajor: "",
    yearOfStudy: "",
    gpaOrMarks: "",
    scholarshipId: "",
    category: "",
    applicationDate: today,
    documents: null,
    extraCurricularActivities: "",
    awardsAchievements: "",
    notesComments: "",
    status: "",

      createdBy: "",
  modifiedBy: "",
  studentId:Number(localStorage.getItem("userId"))
  };
  const [formData, setFormData] = useState(initialFormData);

  const [errors, setErrors] = useState({});
  const [selectedFiles, setSelectedFiles] = useState([]);
  //const [filesList, setFilesList] = useState([]);
  // --- State ---
  const [filesList, setFilesList] = useState(formData?.files || []);
  const [fileSelected, setFileSelected] = useState(false);
  const [newFileSelected, setNewFileSelected] = useState(false);
 const [existingDocFiles, setExistingDocFiles] = useState([]);
const [originalFiles, setOriginalFiles] = useState([]);

const RequiredMark = () => <span className="validation-error-label">*</span>;
const requiredProfileFields = [
  "firstName",
  "lastName",
  "gender",
  "email",
  "phoneNumber",
];
const isProfileIncomplete = requiredProfileFields.some(
  key => !localStorage.getItem(key) || localStorage.getItem(key).trim() === ""
);
console.log(isProfileIncomplete,"isProfileIncomplete")
const convertDOB = (dateStr) => {
  if (!dateStr) return { inputFormat: "", displayFormat: "" };

  const [datePart] = dateStr.split(" "); // remove time
  const [mm, dd, yyyy] = datePart.split("/");

  return {
    inputFormat: `${yyyy}-${mm}-${dd}`,     // backend format
    displayFormat: `${dd}/${mm}/${yyyy}`,   // UI display
  };
};
const rawDOB = localStorage.getItem("dateOfBirth");
const { inputFormat, displayFormat } = convertDOB(rawDOB);


  // Populate form if editing
useEffect(() => {
  const localData = {
    firstName: localStorage.getItem("firstName") || "",
    lastName: localStorage.getItem("lastName") || "",
    email: localStorage.getItem("email") || "",
    phoneNumber: localStorage.getItem("phoneNumber") || "",
    gender: localStorage.getItem("gender") || "",
    dateOfBirth: inputFormat,       // <- internal use
    dateOfBirthDisplay: displayFormat, // <- UI display value
  };

  if (application) {
    // Edit mode → still autofill from localStorage
    setFormData({
      ...initialFormData,
      ...application,
      ...localData,
      dateOfBirth:
        localData.dateOfBirth ||
        (application.dateOfBirth?.split("T")[0] || ""),
      applicationDate: application.applicationDate
        ? application.applicationDate.split("T")[0]
        : today,
      scholarshipId: application.scholarshipId
        ? parseInt(application.scholarshipId)
        : "",
      modifiedBy: localStorage.getItem("name"),
    });
  } else {
    // New application
    setFormData({
      ...initialFormData,
      ...localData,
      createdBy: localStorage.getItem("name"),
      studentId: Number(localStorage.getItem("userId")),
    });
  }

  setErrors({});
}, [application, show]);

useEffect(() => {
    if (application?.files?.length > 0) {
      setExistingDocFiles([...application.files]);
       setOriginalFiles([...application.files]); // ✅ immutable backup
    }
  }, [application]);
// Remove backend file
const handleRemoveSingleFile = (index) => { 
  const updatedFiles = existingDocFiles.filter((_, i) => i !== index);
  setExistingDocFiles(updatedFiles);

  setFormData(prev => ({
    ...prev,
    files: updatedFiles,
    FileName: updatedFiles.length > 0 ? updatedFiles.join("|") : "",
  }));
};
  /* const handleChange = (e) => {
     const { name, value, files } = e.target;
     let regex = null;
 
     switch (name) {
       case "firstName":
       case "lastName":
         regex = nameRegex;
         break;
       case "phoneNumber":
         regex = phoneRegex;
         break;
       case "courseOrMajor":
         regex = courseRegex;
         break;
       case "schoolName":
         regex = collegeRegex;
         break;
       case "yearOfStudy":
         regex = yearRegex;
         break;
       case "gpaOrMarks":
         regex = gpaRegex;
         break;
       case "scholarshipId":
         regex = scholarshipRegex;
         break;
       case "extraCurricularActivities":
       case "awardsAchievements":
       case "notesComments":
         regex = text250Regex;
         break;
       default:
         regex = null;
     }
 
     if (files) {
       setFormData({ ...formData, [name]: files[0] });
     } else {
       if (!regex || regex.test(value)) {
         setFormData({ ...formData, [name]: name === "scholarshipId" ? parseInt(value) : value });
       }
     }
     setErrors({ ...errors, [name]: "" });
   };*/
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    let regex = null;

    switch (name) {
      case "firstName":
      case "lastName":
        regex = nameRegex;
        break;
      case "phoneNumber":
  regex = phoneRegex;
  break;
      case "courseOrMajor":
        regex = courseRegex;
        break;
      case "schoolName":
        regex = collegeRegex;
        break;
      case "yearOfStudy":
        regex = yearRegex;
        break;
      case "gpaOrMarks":
        regex = gpaRegex;
        break;
      case "scholarshipId":
        regex = scholarshipRegex;
        break;
      case "extraCurricularActivities":
      case "awardsAchievements":
      case "notesComments":
        regex = text250Regex;
        break;
      default:
        regex = null;
    }
 if (name === "phoneNumber") {
    let cleaned = value.replace(/\D/g, "");
    cleaned = cleaned.slice(0, 10);
    setFormData({ ...formData, phoneNumber: cleaned });
    setErrors({ ...errors, phoneNumber: "" });
    return;
  }
    if (files) {
      const fileArray = Array.from(files);
      setSelectedFiles(fileArray);
      setFilesList(fileArray.map((f) => f.name));
    } else {
      /* if (!regex || regex.test(value)) {
         setFormData({
           ...formData,
           [name]: name === "scholarshipId" ? parseInt(value) : value,
         });
       }*/
     // Year of Study: Only allow past or current year, block future
if (name === "yearOfStudy") {
  let cleaned = value.replace(/\D/g, "").slice(0, 4); // only digits, max 4 chars

  if (cleaned === "") {
    setFormData({ ...formData, yearOfStudy: "" });
    return;
  }

  const enteredYear = Number(cleaned);
  const currentYear = new Date().getFullYear();

  // ❌ Block typing future year
  if (enteredYear > currentYear) {
    return; // DO NOT UPDATE STATE
  }

  setFormData({ ...formData, yearOfStudy: cleaned });
  return;
}
 let updatedFormData = { ...formData };
        if (name === "yearOfStudy") {
      let cleaned = value.replace(/\D/g, "").slice(0, 4);
      setFormData({ ...formData, yearOfStudy: cleaned });
      return;
    }
    
    // Marks: allow only 0–100
if (name === "gpaOrMarks") {
  // keep digits AND decimal point
  let cleaned = value.replace(/[^0-9.]/g, "");

  // allow only ONE decimal point
  const dotCount = (cleaned.match(/\./g) || []).length;
  if (dotCount > 1) return;

  // limit to 2 decimal places
  const parts = cleaned.split(".");
  if (parts[1]?.length > 2) return;

  // Block numbers greater than 100
  if (cleaned !== "" && Number(cleaned) > 100) {
    return; // do NOT update the state
  }

  setFormData({ ...formData, gpaOrMarks: cleaned });
  return;
}



      if (!regex || regex.test(value)) {
        updatedFormData[name] =
          name === "scholarshipId" ? parseInt(value) : value;
      }

      // ✅ When a scholarship is selected, set the corresponding type in category
      if (name === "scholarshipId") {
        const selected = scholarshipOptions.find(
          (s) => s.id === parseInt(value)
        );
        if (selected) {
          updatedFormData.category = selected.type || "";
        } else {
          updatedFormData.category = "";
        }
      }

      setFormData(updatedFormData);
    }
    setErrors({ ...errors, [name]: "" });
  };


  // --- Clear function ---
  const handleClear = () => {
    setSelectedFiles([]);
    setFilesList([]);
    setExistingDocFiles([]);
    setFormData(prev => ({
      ...prev,
      FileName: "",
      //FilePath: ""
    }));// ✅ tell backend all removed
    setFileSelected(false);
    setNewFileSelected(false);

    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  // --- File change handler ---
    const handleFileChange = (e) => {
      const files = Array.from(e.target.files);
      if (!files || files.length === 0) return;
  
      const allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ];
  
      const invalidFiles = files.filter(f => !allowedTypes.includes(f.type));
  
      if (invalidFiles.length > 0) {
        Swal.fire(
          "Invalid File",
          "Only PDF, DOC, DOCX, XLS, XLSX files are allowed",
          "warning"
        );
        return;
      }
  
      setSelectedFiles(files);
      setFilesList(files.map(f => f.name));
      setFileSelected(true);
      setNewFileSelected(true);
    };
  
  // Upload files function returns uploaded file names
  const uploadFiles = async (applicationId) => {
    if (selectedFiles.length < 1) return [];

    const formDataPayload = new FormData();
    selectedFiles.forEach((file) => formDataPayload.append("FormFiles", file));
    formDataPayload.append("TypeofUser", "SchAppForm");
    formDataPayload.append("id", applicationId);

    try {
      await uploadFormFilesReq(formDataPayload);

      // Return names of uploaded files for merging
      return selectedFiles.map(f => f.name);
    } catch (ex) {
      console.error("File upload failed:", ex);
      return [];
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Mandatory fields:
    if (!formData.firstName.trim())
      newErrors.firstName = "First Name is required.";

   if (!formData.email.trim()) {
  newErrors.email = "Email is required.";
} else if (!isValidEmail(formData.email)) {
  newErrors.email = "Enter a valid email address.";
}


    if (!formData.studyLevel)
      newErrors.studyLevel = "Study Level is required.";

    if (!formData.scholarshipId)
      newErrors.scholarshipId = "Scholarship selection is required.";

    if (!formData.category)
      newErrors.category = "Category is required.";

    if (!formData.applicationDate)
      newErrors.applicationDate = "Application Date is required.";

    // Optional fields with validation:
    if (formData.phoneNumber && formData.phoneNumber.length !== 10)
  newErrors.phoneNumber = "Phone must be exactly 10 digits.";


    if (formData.lastName && !nameRegex.test(formData.lastName))
      newErrors.lastName = "Last Name must contain only letters.";

     if (formData.yearOfStudy) {
      const enteredYear = parseInt(formData.yearOfStudy);
      const currentYear = new Date().getFullYear();

      if (isNaN(enteredYear)) {
        newErrors.yearOfStudy = "Enter a valid year.";
      } else if (enteredYear > currentYear) {
        newErrors.yearOfStudy =
          `Year cannot be greater than ${currentYear}.`;
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /*const handleSubmit = (e, statusType) => {
    e.preventDefault();
    if (!validateForm()) return;

    const finalData = { ...formData, status: statusType };

    if (application) {
      updateScholarshipApplication(finalData, dispatch);
    } else {
      addNewScholarshipApplication(finalData, dispatch);
    }

    handleCloseAndReset();
  };*/
  const handleSubmit = async (e, statusType) => {
  e.preventDefault();
  if (!validateForm()) return;

  const finalData = {
    ...formData,
    status: statusType,
    dateOfBirth: formData.dateOfBirth || null,
    yearOfStudy: formData.yearOfStudy || null,
    phoneNumber: formData.phoneNumber || "",
    schoolName: formData.schoolName || "",
    courseOrMajor: formData.courseOrMajor || "",
    documents: null,
  };

  let applicationId = null;
  let updatedApp = null;
  let emailError = false; // ✅ Track email status

  /* =============================
     1️⃣ INSERT / UPDATE
  ============================== */
  try {
    if (application) {
      applicationId = application.id;
      await updateScholarshipApplication(finalData, dispatch);
    } else {
      const res = await addNewScholarshipApplication(finalData, dispatch);
      applicationId = res?.id;
    }

    // Upload files
    if (applicationId && selectedFiles.length > 0) {
      await uploadFiles(applicationId);
    }

    // Fetch latest data
    updatedApp = await fetchScholarshipApplicationByIdReq(applicationId);

    setFormData((prev) => ({
      ...prev,
      ...updatedApp.data,
      dateOfBirth: updatedApp.data.dateOfBirth
        ? updatedApp.data.dateOfBirth.split("T")[0]
        : "",
      applicationDate: updatedApp.data.applicationDate
        ? updatedApp.data.applicationDate.split("T")[0]
        : today,
    }));

    setSelectedFiles([]);

  } catch (appErr) {
    console.error("Application Save Error:", appErr);

    Swal.fire({
      title: "Application Failed",
      text:
        appErr?.response?.data?.message ||
        "Application could not be saved. Please try again.",
      icon: "error",
    });

    // ❌ STOP HERE — DO NOT CALL EMAIL
    return;
  }

  /* =============================
     2️⃣ EMAIL SEND (ONLY IF SAVE SUCCESS)
  ============================== */
  if (updatedApp?.data[0]?.status === "Submitted") {
    try {
      await sendScholarshipEmailReq(applicationId);
    } catch (mailErr) {
      emailError = true; // mark that email failed

      const errorMessage =
        mailErr?.response?.data?.message ||
        mailErr?.message ||
        "Application submitted successfully, but error sending email to sponsor.";

      Swal.fire({
        title: "Email Not Sent",
        text: errorMessage,
        icon: "warning",
      });

      console.error("Email Error:", mailErr);
    }
  }

  /* =============================
     3️⃣ SUCCESS MESSAGE (ONLY IF EMAIL SUCCEEDED OR NOT NEEDED)
  ============================== */
  if (!emailError) {
    await Swal.fire({
      text: application
        ? "Application updated successfully!"
        : "Application submitted successfully!",
      icon: "success",
      confirmButtonText: "OK",
    });
  }

 navigation("/application");
  handleCloseAndReset();
};



  const handleCloseAndReset = () => {
  // 🔥 Restore ORIGINAL backend files
  setExistingDocFiles([...originalFiles]);

  setFormData(prev => ({
    ...prev,
    files: [...originalFiles],
    FileName: originalFiles.join("|")
  }));

  setErrors({});
  setSelectedFiles([]);
  setFilesList([]);
  setFileSelected(false);
  setNewFileSelected(false);
  //setLogoFile(null);
  //setLogoFileName("");

  if (fileInputRef.current) {
    fileInputRef.current.value = null;
  }

  handleClose();
};


  const downloadFileFun = async (id) => {
    try {
      //const res = await AsyncGetFiles(API.downloadScholarshipFiles + "?id=" + id);
      //const res= await 
      const res = await publicAxios.get(
        `${ApiKey.downloadscholarshipFiles}/${id}/${"ScholarshipApplication"}`,
        { responseType: "blob" }   // <-- important for file download
      );


      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "application/zip" })
      );

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "documents.zip"); // you can rename as needed
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (err) {
      console.error("File download failed:", err);
    }
  };

  if (!show) return null; // Do not render if modal hidden

  const Required = () => <span style={{ color: "red" }}> *</span>;

  return (
    <div className="modal-overlay">
      <div className="modal">
        {/* Header */}
        <div className="modal-header">
         <span><strong>
  {mode === "view"
    ? "View Application"
    : application
    ? "Edit Application"
    : "New Application"}
</strong></span>

          <button className="close-btn" onClick={handleCloseAndReset}>×</button>
        </div>

        {/* Body */}
        <div className="modal-body">
          <form>
           {/* <div className="personal-info-header" style={{paddingBottom: "10px",
    paddingTop: "10px"}}>
    <span><strong>Personal Information</strong></span>

    {isProfileIncomplete && (
      <span className="profile-error">
        ⚠️ Please update your profile
      </span>
    )}
  </div>*/}<div
  className="personal-info-header"
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "20px 0",
  }}
>
  <h4 style={{ margin: 0 }}>Personal Information</h4>

  {isProfileIncomplete && (
    <span className="profile-error">
      ⚠️ Please update your profile
    </span>
  )}
</div>


            <div className="row">
              <div className="form-group col-6">
                <label>First Name <RequiredMark /></label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  className={errors.firstName ? "input-error" : ""}
                  placeholder="First Name"
                  disabled
                />
                {errors.firstName && <p className="error-text">{errors.firstName}</p>}
              </div>
            </div>
            <div className="row">

              <div className="form-group col-6">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  className={errors.lastName ? "input-error" : ""}
                  placeholder="Last Name"
                  disabled
                />
                {errors.lastName && <p className="error-text">{errors.lastName}</p>}
              </div>
            </div>

            <div className="row">
              <div className="form-group col-6">
                <label>Email <Required /></label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className={errors.email ? "input-error" : ""}
                  placeholder="Email"
                  disabled
                />
                {errors.email && <p className="error-text">{errors.email}</p>}
              </div>
            </div>
            <div className="row">

              <div className="form-group col-6">
                <label>Phone</label>
                <input
                  type="text"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  className={errors.phoneNumber ? "input-error" : ""}
                  placeholder="Phone"
                  disabled
                />
                {errors.phoneNumber && <p className="error-text">{errors.phoneNumber}</p>}
              </div>
            </div>

            <div className="row">
              <div className="form-group col-6">
                <label>Date of Birth</label>
                <input
                  type="date"
                  name="dateOfBirth"
                  value={formData.dateOfBirth}
                  min={minAllowedDOB}
                  max={maxDOB}
                  onChange={handleChange}
                  disabled
                />
              </div>

              <div className="form-group col-6">
                <label>Gender</label>
                <select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  disabled
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Others</option>
                </select>
              </div>
            </div>

            <h4 className="mt-3">Academic Information</h4>

            <div className="row">
              <div className="form-group col-6">
                <label>Study Level <Required /></label>
                <select
                 disabled={isViewMode}
                  name="studyLevel"
                  value={formData.studyLevel}
                  onChange={handleChange}
                  className={errors.studyLevel ? "input-error" : ""}>
                  <option value="">Select Study Level</option>
                   <option value="School">School</option>
                  <option value="UG">Undergraduate</option>
                  <option value="PG">Postgraduate</option>
                  <option value="PhD">Ph.D.</option>
                </select>

                {errors.studyLevel && (
                  <p className="error-text">{errors.studyLevel}</p>
                )}
              </div>
            </div>
            <div className="row">
              <div className="form-group col-6">
                <label>School/College</label>
                <input
                  type="text"
                  name="schoolName"
                  value={formData.schoolName}
                  onChange={handleChange}
                  disabled={isViewMode}
                />
              </div>

            </div>

            <div className="row">
              <div className="form-group col-6">
                <label>Class/Course / Major</label>
                <input
                  type="text"
                  name="courseOrMajor"
                  value={formData.courseOrMajor}
                  onChange={handleChange}
                  disabled={isViewMode}
                />
              </div>
            </div>
            <div className="row">


              <div className="form-group col-6">
                <label>Year of Study</label>
               <input
                  type="text"
                  name="yearOfStudy"
                  value={formData.yearOfStudy}
                  onChange={handleChange}
                  disabled={isViewMode}
                />
                {errors.yearOfStudy && (
                  <p className="error-text">{errors.yearOfStudy}</p>
                )}
              </div>
            </div>

            <div className="row">
              <div className="form-group col-6">
                <label>Marks</label>
                <input
                  type="text"
                  name="gpaOrMarks"
                  value={formData.gpaOrMarks}
                  onChange={handleChange}
                  disabled={isViewMode}
                />
              </div>
              </div>

              <div className="row">
                <div className="form-group col-6">
                  <label>Scholarship Name <Required /></label>

                  <select
                    name="scholarshipId"
                    value={formData.scholarshipId}
                    onChange={handleChange}
                    className={errors.scholarshipId ? "input-error" : ""}
                    disabled={isViewMode}
                  >
                    <option value="">Select Scholarship</option>
                    {scholarshipOptions.map((sch) => (
                      <option key={sch.id} value={sch.id}>{`${sch.scholarshipCode} - ${sch.name}`}</option>
                    ))}
                  </select>

                  {errors.scholarshipId && (
                    <p className="error-text">{errors.scholarshipId}</p>
                  )}
                </div>
              
            </div>

            <div className="row">
              <div className="form-group col-6">
                <label>Category </label>
                <select
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  disabled // category is auto-filled, not user-editable

                >
                  <option value="">Select Category</option>
                  {formData.category && (
                    <option value={formData.category}>
                      {formData.category}
                    </option>
                  )}
                </select>
              </div>

              <div className="form-group col-6">
                <label>Application Date</label>
                <input
                  type="date"
                  name="applicationDate"
                  value={formData.applicationDate}
                  min={today}
                  max={today}
                  onChange={handleChange}
                  disabled={isViewMode}
                />
              </div>
            </div>

            <div className="row">
              {/*<div className="form-group col-12">
    <label>Upload Documents</label>
    <input
      type="file"
      name="documents"
      onChange={handleChange}
      multiple
    />

    Show uploaded files from backend if present 
    {formData?.files && formData.files.length > 0 && (
      <div className="mt-2">
        {formData.files.map((fileName, index) => (
          <div
            key={index}
            className="d-flex align-items-center mt-1 border rounded p-2"
          >
            <div className="flex-grow-1">
              <h6 className="mb-0">{fileName}</h6>
            </div>
            <button
              type="button"
              className="btn btn-sm btn-primary ms-2"
           onClick={() => downloadFileFun(formData.id)}
            >
              Download
            </button>
          </div>
        ))}
      </div>
    )}
    {formData?.files && formData.files.length > 0 && (
  <div className="mt-2 border rounded p-3">
   

    
    <ul className="mb-2">
      {formData.files.map((fileName, index) => (
        <li key={index}>{fileName}</li>
      ))}
    </ul>

    
    <button
      type="button"
      className="btn btn-sm btn-primary"
      onClick={() => downloadFileFun(formData.id)}
    >
      Download
    </button>
  </div>
)}*/}


         {isViewMode ? (
  /* ================= VIEW MODE ================= */
  <div className="form-group col-12">
    <label>Uploaded Documents</label>

    <div style={{ textAlign: "left" }}>
      {formData?.files?.length > 0 ? (
        formData.files.map((fileName, index) => (
          <div key={index} style={{ padding: "5px 0" }}>
            {fileName || "No File Name"}
          </div>
        ))
      ) : (
        <div>No files uploaded</div>
      )}
    </div>
  </div>
) : (
  /* ================= EDIT MODE ================= */
  <div className="form-group col-12">
    <label>Upload Documents</label>

    <input
      type="file"
      name="documents"
      multiple
      ref={fileInputRef}
accept=".pdf,.doc,.docx,.xls,.xlsx"

      onChange={handleFileChange}
    />

    {fileSelected && filesList.length > 0 && (
      <button
        type="button"
        className="btn btn-sm btn-danger mt-2"
        onClick={handleClear}
        style={{ marginTop: "10px" }}
      >
        Clear
      </button>
    )}

    {(formData?.files?.length > 0 || filesList.length > 0) && (
      <div className="d-flex flex-column mt-2 rounded"style={{ marginTop: "5px" }}>
        {/* Backend files */}
        {formData?.files?.map((fileName, index) => (
          <div
            key={`backend-${index}`}
            className="d-flex align-items-center justify-content-between border rounded p-2 mb-1"
          >
            <span>{fileName || "No File Name"}</span>

            <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleRemoveSingleFile(index)}
              style={{ marginLeft: "5px" }}
            >
              ×
            </button>
          </div>
        ))}

        {/* Download button */}
        {formData?.files?.length > 0 && (
          <button
            type="button"
            className="btn btn-sm btn-primary mt-2"
            onClick={() => downloadFileFun(formData.id)}
          >
            Download
          </button>
        )}
      </div>
    )}
  </div>
)}






            </div>


            <h4 className="mt-3">Additional Information</h4>
            <div className="row">
              <div className="form-group col-12">
                <label>Extra-Curricular</label>
                <textarea name="extraCurricularActivities" value={formData.extraCurricularActivities} onChange={handleChange}
                disabled={isViewMode}></textarea>
              </div>
            </div>
            <div className="row">

              <div className="form-group col-12">
                <label>Awards / Achievements</label>
                <textarea name="awardsAchievements" 
                disabled={isViewMode}
                value={formData.awardsAchievements} onChange={handleChange}></textarea>
              </div>
            </div>
            <div className="row">

              <div className="form-group col-12">
                <label>Notes / Comments</label>
                <textarea name="notesComments"
                disabled={isViewMode}
                 value={formData.notesComments} onChange={handleChange}></textarea>
              </div>
            </div>
          </form>
        </div>

 
        {/* Footer Actions */}
        <div className="modal-actions">
  <button className="sign-action-btn1 danger" onClick={handleCloseAndReset}>
    {isViewMode ? "Close" : "Cancel"}
  </button>

  {!isViewMode && (
    <>
      <button className="sign-action-btn1" onClick={(e) => handleSubmit(e, "Draft")}>
        Save Draft
      </button>

      <button className="sign-action-btn1" onClick={(e) => handleSubmit(e, "Submitted")}>
        {application ? "Submit" : "Submit"}
      </button>
    </>
  )}
</div>

      </div>
    </div>
  );
};

export default AddApplicationModal;
